/**
 * Cases stored at /World/{uid}/settings/agents.
 *
 * DataSnapshot.forEach stops at the first truthy return value. Array.push
 * returns the new length, so `snapshot.forEach(child => list.push(...))`
 * keeps only the first case and every later one never reaches the list.
 */
const agentsFromSnapshot = (snapshot) => {
  const list = [];
  if (!snapshot || typeof snapshot.forEach !== 'function') return list;
  snapshot.forEach((child) => {
    const value = typeof child.val === 'function' ? child.val() : null;
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      list.push({ id: child.key, ...value });
    }
  });
  return list;
};

export default agentsFromSnapshot;
